import React from 'react';
import _ from 'lodash';

interface Props {
  status: any;
}
export default class BulkCreateActionProjects extends React.Component<Props> {
  getStatusClass = (bulkAction: any): string =>
    bulkAction.isSuccess() ? 'green' : bulkAction.isFail() ? 'red' : 'gray';

  render() {
    const { status } = this.props;
    return (
      <table className="organization__table">
        <thead>
          <tr>
            <th className="organization__th">プロジェクトコード</th>
            <th className="organization__th">処理結果</th>
          </tr>
        </thead>
        <tbody>
          {status.actionProjects.map((project: any, i: number) => (
            <tr key={i} className="organization__tr">
              <td className="organization__td e2e-code">{project.code}</td>
              <td className={`organization__td e2e-status ${this.getStatusClass(project)}`}>
                {project.statusMessage()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
